module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_03@3x-012e72fd93e77eed1681d0bad27ad362.webp";